/* eslint-disable @typescript-eslint/camelcase */

import * as Rox from "rox-browser";
import { FcsFlag } from "../unleash";

const fcsFlagsReport = {
  laporan_download_stt: new FcsFlag.Flag(false),
  laporan_download_stt_book_for_klien: new FcsFlag.Flag(false),
  laporan_download_stt_book_for_pos: new FcsFlag.Flag(false),
  laporan_download_stt_manual: new FcsFlag.Flag(false),
  laporan_download_pembatalan_stt: new FcsFlag.Flag(false),
  laporan_download_top_up: new FcsFlag.Flag(false),
  laporan_download_referral_pos: new FcsFlag.Flag(false),
  laporan_download_komisi_affiliate: new FcsFlag.Flag(false),
  laporan_download_komisi_pos_induk: new FcsFlag.Flag(false),
  laporan_download_misroute: new FcsFlag.Flag(false),
  laporan_download_shortland: new FcsFlag.Flag(false),
  laporan_download_pengiriman: new FcsFlag.Flag(false),
  laporan_download_scrap: new FcsFlag.Flag(false),
  laporan_download_pengiriman_keluar: new FcsFlag.Flag(false),
  laporan_download_pengiriman_masuk: new FcsFlag.Flag(false),
  laporan_download_komisi_pengiriman: new FcsFlag.Flag(false),
  laporan_download_komisi_pengiriman_tier_x: new FcsFlag.Flag(false),
};

const roxFlagsReport = {
  report_enable: new Rox.Flag(false),
  report_bonus_komisi: new Rox.Flag(false),
  permission_report_view_stt: new Rox.Flag(false),
  permission_report_view_stt_client: new Rox.Flag(false),
  config_maximum_range_day_stt_report: new Rox.RoxNumber(0),
};

export const FlagsPermissionReport = {
  ...fcsFlagsReport,
  ...roxFlagsReport
};

export function initFlagsPermissionReport() {
  // register flags with namespaces for better grouping
  Rox.register("featureReport", roxFlagsReport);
  FcsFlag.register("featureReport", fcsFlagsReport);
}
